import { CampaignDealTypeSchema as n } from "./schemas.js";
const a = "CampaignDealType_", t = (e) => e.startsWith(a) ? e.slice(a.length) : e, m = n.enum.CampaignDealType_None;
export {
  m as DEFAULT_CAMPAIGN_PRIORITY,
  t as stripDealTypePrefix
};
//# sourceMappingURL=campaign-priority.js.map
